import { makeStyles } from "@fluentui/react-components";

export const mapStyles = makeStyles({
  mapContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "8px",
    zIndex: 0,
  },
  mapControlContainer: {
    position: "absolute",
    top: "12px",
    right: "12px",
    fontWeight: 500,
    zIndex: 1000,
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
});

export const mapDisplayErrorStyles = makeStyles({
  airportMap: {
    right: "0px",
    marginTop: "44px",
  },
  flightMap: {
    right: "180px",
  },
  singleFlightMap: {
    right: "0px",
  },
});

export const mapControlsStyles = makeStyles({
  cardContainer: {
    padding: "8px",
    backgroundColor: "rgba(255,255,255,0.55)",
    backdropFilter: "saturate(180%) blur(6px)",
    borderRadius: "8px",
    border: `1px solid rgba(0,0,0,0.2)`,
  },
  toggleControls: {
    display: "flex",
    flexDirection: "column",
  },
  viewControls: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  viewControlsLabel: {
    textAlign: "center",
    padding: "8px",
  },
  viewButton: {
    margin: "0 8px",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: 500,
  },
});

export const tooltipStyles = makeStyles({
  tooltip: {
    fontWeight: 600,
    fontSize: "12px",
    opacity: 0.5,
    border: "none",
    zIndex: 10000,
    padding: "10px",
  },
});

export const flightsPaneControlsStyles = makeStyles({
  flightsPaneVisible: {
    "& .leaflet-pane.leaflet-flights-pane-pane": {
      opacity: 1,
      pointerEvents: "auto",
    },
  },

  flightsPaneHidden: {
    "& .leaflet-pane.leaflet-flights-pane-pane": {
      opacity: 0,
      pointerEvents: "none",
    },
  },
});
